import { Button, Flex, Icon } from "orcs-design-system";
import { components, type ControlProps } from "react-select";

const CLEAR_ICON = ["fas", "times"] as const;

type SearchSelectProps = {
  inputValue?: string;
  onClearSearchQuery?: () => void;
};

// The field is row-reverse. order -1 keeps this after the input in the DOM
// and paints it on the right.
const SearchControl = (props: ControlProps) => {
  const selectProps = props.selectProps as SearchSelectProps;
  const term = selectProps.inputValue;
  const onClear = selectProps.onClearSearchQuery;
  const showClear =
    typeof onClear === "function" &&
    typeof term === "string" &&
    term.trim().length > 0;

  return (
    <components.Control {...props}>
      {props.children}
      {showClear ? (
        <Flex order={-1} alignItems="center">
          <Button
            type="button"
            variant="subtle"
            small
            iconOnly
            ariaLabel="Clear search"
            dataTestId="search-query-clear"
            onMouseDown={(event) => {
              event.preventDefault();
              event.stopPropagation();
            }}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onClear();
            }}
          >
            <Icon icon={CLEAR_ICON} />
          </Button>
        </Flex>
      ) : null}
    </components.Control>
  );
};

export default SearchControl;
